<template>
    <div>

        <div style="width:350px;margin:0 auto">
            <img :src="url" class="paytmimg" alt="">
            <div class="caption" style="text-align:center;margin-bottom:10px;color:blue" >Flat 0% Commission</div>
            <v-text-field
                type="text"
                style="width:350px;margin:0 auto;height:60px"
                label="UPI Loaded Amount"
                v-model="amount"
                solo />
            <v-text-field
                type="text"
                style="width:350px;margin:0 auto;height:60px"
                label="UPI Transaction ID"
                v-model="id"
                solo />
            <div style="width:100%;float:left;height:80px;">
                <v-btn color="primary" style="width:350px;margin:0 auto;" @click="submit">Pay Now</v-btn>
                <v-btn  style="width:350px;margin:0 auto;" color="error"  flat >{{charge}}</v-btn>
            </div>
        </div>
            <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>

    </div>
</template>
<script>
export default {
    props:['charge','url'],
    data(){
        return{
            id:"",
            amount:"",
            dialog:false
        }
    },
    computed:{
        user(){
            return this.$store.getters.user
        }
    },

    methods:{
        notification(type,message){
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
            })
        },
        submit(){
            let vm = this;
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
            if(vm.amount=="")return vm.notification("error","Amount Required")
            if(vm.id=="")return vm.notification("error","Transaction ID Required")
             let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json',
                'PaymentMode':'DirectUPI',
                'PaymentType':'Wallet',
                'TransId':vm.id,
                'Amount':vm.amount,
                'Mode':'Load'
            }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                    url:"Load_Balance",
                    data:doc,
            }).then(function (res) {
                    console.log(res);
                    vm.dialog = false;
                    vm.$store.dispatch("getbalance")
                    if(res.data.Status==null) vm.notification("error","Try Agian!");
                    if(res.data.Status=="False"){
                    if(res.data.Message=="Not Authorised."){
                        window.localStorage.removeItem("user");
                        vm.$store.dispatch("getuser");
                        vm.$router.push("/account");
                        return vm.notification("error",res.data.Message);
                    }
                        return vm.notification("error",res.data.Message);
                    }
                    if(res.data.Status=="True"){
                       vm.id ="";
                       vm.amount ="";
                       return vm.notification("success",res.data.Message);
                    }

            }).catch(function (error) {
                    console.log(error);
                    vm.notification("error",error);
                    vm.dialog = false;
            })

        }
    }
}
</script>

<style scoped>
.paytmimg{
        width: 170px;
        margin-left:85px;
        }
</style>

